const resetGlobals = (Variables, setGlobalVariableValue) => {
  setGlobalVariableValue({
    key: 'TOTAL_INCOME',
    value: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  });
  setGlobalVariableValue({
    key: 'TOTAL_CASH_PAID',
    value: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  });
  setGlobalVariableValue({
    key: 'STARTING_CASH',
    value: 0,
  });
  setGlobalVariableValue({
    key: 'TOTAL_CASH_ON_HAND',
    value: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  });
  setGlobalVariableValue({
    key: 'PRODUCT_PAYMENT_COSTS',
    value: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  });
  setGlobalVariableValue({
    key: 'FINANCE_EXPENSES',
    value: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  });
  setGlobalVariableValue({
    key: 'OPERATING_EXPENSES',
    value: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  });
  setGlobalVariableValue({
    key: 'PAYROLL_EXPENSES',
    value: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  });
  setGlobalVariableValue({
    key: 'EXPENSES',
    value: '',
  });
  setGlobalVariableValue({
    key: 'STARTING_DATE',
    value: '',
  });
  setGlobalVariableValue({
    key: 'CASH_ON_HAND',
    value: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  });
};

export default resetGlobals;
